interface TechStackProps {
 title?: string;
 technologies: string[];
}

export function TechStack({ title = "Technologies", technologies }: TechStackProps) {
 if (technologies.length === 0) return null;

 return (
 <section className="py-12">
 <h2 className="text-2xl font-bold text-foreground mb-6">{title}</h2>
 <div className="flex flex-wrap gap-3">
 {technologies.map((tech, i) => (
 <span
 key={i}
 className="px-4 py-2 bg-muted/70 border border-border rounded-xl text-sm font-medium text-foreground/80 hover:bg-primary/10 hover:text-primary hover:border-primary/30 hover:shadow-sm hover:shadow-primary/5 transition-all duration-300 backdrop-blur-sm"
 >
 {tech}
 </span>
 ))}
 </div>
 </section>
 );
}
